import { BigNumber } from 'ethers'

export function getPackCount(minted: BigNumber | undefined, max: BigNumber | undefined) {
  return max && minted ? max.sub(minted).toString() : '-'
}
